import api from '../../../../api';

export const TableSelector = {
  TABLE: api.internals.ns.selector('table')
};
